import styled from '@emotion/styled';
import { uiTheme as t } from './theme';

/**
 * Piezas de encuadre que comparten las pantallas de definición: el aire de la
 * página, el encabezado con su acción, la barra de búsqueda y filtros, y la
 * barra flotante de selección.
 *
 * Son solo `styled`, sin lógica: cada pantalla decide qué mete dentro. Estaban
 * copiadas una vez por página, y una separación distinta en cada copia es
 * exactamente lo que hace que dos pantallas hermanas dejen de parecerse.
 */

export const PageBody = styled.div({
  flex: 1,
  padding: '28px 32px 56px',
});

export const Header = styled.div({
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'space-between',
  gap: 20,
  flexWrap: 'wrap',
});

export const Title = styled.h2({
  margin: 0,
  fontFamily: t.font,
  fontSize: 21,
  fontWeight: 600,
  color: t.color.title,
});

export const Subtitle = styled.p({
  margin: '6px 0 0',
  maxWidth: 620,
  fontFamily: t.font,
  fontSize: 13.5,
  color: t.color.muted,
});

export const Toolbar = styled.div({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 16,
  marginTop: 24,
  flexWrap: 'wrap',
});

/** Lado derecho de la barra: filtros y contadores. */
export const ToolbarEnd = styled.div({
  display: 'flex',
  alignItems: 'center',
  gap: 14,
  flexWrap: 'wrap',
});

export const SelectionNote = styled.span({
  fontFamily: t.font,
  fontSize: 13.5,
  color: t.color.muted,
  whiteSpace: 'nowrap',
});

export const LoadingState = styled.div({
  marginTop: 36,
  fontFamily: t.font,
  fontSize: 14,
  color: t.color.muted,
});

/** Franja para las listas heredadas que se muestran sobre la tabla. */
export const Stack = styled.div({
  marginTop: 22,
  display: 'flex',
  flexDirection: 'column',
  gap: 12,
});

// Flotante y no en el flujo: si empujara la tabla, marcar una casilla movería
// bajo el cursor la fila de al lado. z-index por debajo del Drawer (1200) y del
// Dialog (1300) de MUI, para que la barra no se monte sobre ellos.
export const BulkBar = styled.div({
  position: 'fixed',
  bottom: 24,
  left: '50%',
  transform: 'translateX(-50%)',
  zIndex: 1100,
  // Sin esto el bloque flotante encoge al ancho disponible y los botones se
  // parten en dos filas.
  width: 'max-content',
  maxWidth: 'calc(100vw - 48px)',
  padding: '10px 12px 10px 18px',
  display: 'flex',
  alignItems: 'center',
  gap: 18,
  background: t.color.surface,
  border: `1px solid ${t.color.primary}`,
  borderRadius: t.radius.button,
  boxShadow: '0 12px 32px rgba(16, 24, 40, 0.22)',
});

export const BulkCount = styled.span({
  fontFamily: t.font,
  fontSize: 13.5,
  fontWeight: 600,
  color: t.color.title,
  whiteSpace: 'nowrap',
});

export const BulkActions = styled.div({
  display: 'flex',
  alignItems: 'center',
  gap: 10,
  whiteSpace: 'nowrap',
});
